import _classCallCheck from "/builds/fahrschulerauscher/fahrschulerauscher.de/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var SubmitError = function SubmitError() {
  _classCallCheck(this, SubmitError);
};

export var SubmitResult = function SubmitResult(res) {
  var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  _classCallCheck(this, SubmitResult);

  this.validationErrors = [];
  this.failed = failed;

  if (failed && res) {
    this.validationErrors = res;
  }
};